import CompanyList from '../pages/company/List';
import CreateCompany from '../pages/company/Create';
import CompanyDetail from '../pages/company/Detail';
import CompanyTeams from '../pages/company/Teams';
import CompanyTeamsActivity from '../pages/company/TeamsActivity';
import CouponList from '../pages/promotion-coupon/List';
import CouponDetails from '../pages/promotion-coupon/Details';
import PromotionOfferList from '../pages/promotion-coupon/List';
import PromotionOfferDetails from '../pages/promotion-coupon/Details';
import EventList from '../pages/event/List';
import EventDetails from '../pages/event/Details';
import AccountList from '../pages/account-admin/List';
import AccountForm from '../pages/account-admin/Details';
import MemberAccountList from '../pages/member-account/List';
import MemberAccountForm from '../pages/member-account/Details';
import MemberSubscriptionList from '../pages/member-order/List';
import MemberSubscriptionDetails from '../pages/member-order/Details';
import MemberActivityList from '../pages/member-activity/List';
import MemberActivityDetails from '../pages/member-activity/Details';
import ProfileForm from '../pages/profile/Details';
import Homepage from '../pages/Homepage';

export const ROLES = {
    ITADMIN: 'ITAdmin',
    EFFECTADMIN: 'EffectAdmin',
    ADMIN: 'Admin',
    MARKETINGSELL: 'MarketingSell',
    PRODUCTTEAM: 'ProductTeam',
    HR: 'HR',
    FINANCE: 'Finance',
    MEMBER: 'Member',
  };
  
export const ROUTES_CONFIG = {
    '/': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.PRODUCTTEAM, ROLES.HR, ROLES.FINANCE, ROLES.MEMBER],
        element: Homepage
    },
    '/profile': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.PRODUCTTEAM, ROLES.HR, ROLES.FINANCE, ROLES.MEMBER],
        element: ProfileForm
    },
    '/admin': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.HR],
        element: AccountList
    },
    '/admin/new': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.HR],
        element: AccountForm
    },
    '/admin/:id': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.HR],
        element: AccountForm
    },
    '/member': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.FINANCE, ROLES.PRODUCTTEAM],
        element: MemberAccountList
    },
    '/member/account': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN],
        element: MemberAccountList
    },
    '/member/account/:id': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN],
        element: MemberAccountForm
    },
    '/member/subscription': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.FINANCE],
        element: MemberSubscriptionList
    },
    '/member/subscription/:id': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.FINANCE],
        element: MemberSubscriptionDetails
    },
    '/member/activity': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.PRODUCTTEAM],
        element: MemberActivityList
    },
    '/member/activity/:id': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.PRODUCTTEAM],
        element: MemberActivityDetails
    },
    '/coupon': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN],
        element: CouponList
    },
    '/coupon/new': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN],
        element: CouponDetails
    },
    '/promotion/offer': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN],
        element: PromotionOfferList
    },
    '/promotion/offer/new': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN],
        element: PromotionOfferDetails
    },
    '/promotion/offer/:id': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN],
        element: PromotionOfferDetails
    },
    '/company': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.PRODUCTTEAM],
        element: CompanyList
    },
    '/company/profile': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.PRODUCTTEAM],
        element: CompanyList
    },
    '/company/profile/new': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.PRODUCTTEAM],
        element: CreateCompany
    },
    '/company/profile/:uuid': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.PRODUCTTEAM],
        element: CompanyDetail
    },
    '/company/profile/:uuid/edit': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.PRODUCTTEAM],
        element: CreateCompany
    },
    '/event': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.PRODUCTTEAM],
        element: EventList
    },
    '/event/new': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.PRODUCTTEAM],
        element: EventDetails
    },
    '/event/:id': {
        roles: [ROLES.ITADMIN, ROLES.EFFECTADMIN, ROLES.ADMIN, ROLES.MARKETINGSELL, ROLES.PRODUCTTEAM],
        element: EventDetails
    },
};